import listSaga from './listSaga'
import recordingSaga from './recordingSaga'
import callStatisticSaga from './callStatisticSaga'
import agentStatisticSaga from './agentStatisticSaga'

const callLogSagas = [listSaga(), recordingSaga(), callStatisticSaga(), agentStatisticSaga()]

export default callLogSagas
